import React, { useState, useEffect } from "react";
import BillingTable from "../../PageComponent/BillingTable/BillingTable";
import { useLocation } from "react-router-dom";
import BillingForm from "../../PageComponent/BillingForm/BillingForm";
import Items from "../../PageComponent/BillingItems/Items";
import BreakPoint from "../../../components/UI/BreakPoints/BreakPoints";
import ContextApi from "../../../HOC/ContextsAPI/ContextApi";
import image1 from "../../../Resources/images/japan.jpg";

import Layout from "../../../HOC/layout/Layout";
import axios from "../../../HOC/CreateAxios/CreateAxios";
function Billing() {
  const location = useLocation();
  // console.log("location", location);
  const tabs = [
    {
      title: "product",
    },
    {
      title: "service",
    },
    {
      title: " offers",
    },
    {
      title: "booking",
    },
  ];
  const [data, setData] = useState([]);
  const getProduct = () => {
    axios
      .get("/product")
      .then((res) => {
        console.log(res);
        setData(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getProduct();
  }, []);

  const [storeData, setStoreData] = useState([]);

  const handleClick = (value) => {
    console.log(storeData, value);
    let findingIndex = storeData.findIndex((x) => x.id === value.id);
    // console.log(findingIndex);
    if (findingIndex > -1) {
      let newArray = storeData;
      let Quantity = Number(newArray[findingIndex].quantity);
      value.quantity = Quantity + 1;
      value.total = Number(newArray[findingIndex].price) * value.quantity;
      // console.log(Price);

      setStoreData([...newArray]);
      console.log(storeData);
    } else {
      setStoreData([...storeData, value]);
      value.quantity = 1;
      value.total = value.price;
    }
  };
  return (
    <ContextApi>
      <Layout>
        <div>
          {/* <BreakPoint /> */}
          <div className="  flex gap-2 mobileL:gap-2   mobileL:px-5 mt-8 w-11/12 mx-auto tablet:w-full tablet:mx-0">
            {tabs.map((val, i) => {
              return (
                <div key={i}>
                  <div
                    className={`${
                      i === 0
                        ? "bg-gray-400"
                        : i === 1
                        ? "bg-green-500"
                        : i === 2
                        ? "bg-red-500"
                        : "bg-blue-500"
                    }  text-white font-semibold rounded-sm hover:bg-opacity-70 cursor-pointer text-lg capitalize  w-fit tablet:w-full px-2.5 tablet:px-10 py-2 Poppins`}
                  >
                    {val.title}
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className={`tablet:grid 
          
         grid-cols-2 tablet:px-2 laptop:px-6  py-4 `}
          >
            <div className="col-span-1">
              {" "}
              <Items data={data} handleClick={handleClick} />
            </div>
            <div className="col-span-1  ">
              <BillingForm
                setStoreData={setStoreData}
                storeData={storeData}
                handleClick={handleClick}
              />
            </div>
          </div>
        </div>
      </Layout>
    </ContextApi>
  );
}

export default Billing;
